// Auto-generated by scripts/gen-version.mjs — do not edit.
export const BUILD_VERSION = "2026.10.11.36-17a4e60";
